import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { MenuItem } from '@/Support/Menus/Interfaces/MenuItem'

export const mainMenu = computed(
  () => usePage().props.mainMenu
) as unknown as MenuItem[]
